export const SERVER_DRONE_URL = process.env.REACT_APP_BACKEND_URL || ''

export const birdnestCoordinates = { x: 250, y: 250 }

export const birdnestRadious = 100
